import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../static/media/logo.webp";

export default function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));

    setMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const email = formData.email.trim().toLowerCase();
    const password = formData.password;

    if (!email || !password) {
      setMessage("Completa el correo y la contraseña.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/access-control/api/web/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.message || "No fue posible iniciar sesión.");
      }

      if (data.user?.user_type !== "ADMIN") {
        throw new Error("No tienes acceso.");
      }

      localStorage.setItem("user_access_token", data.access);
      localStorage.setItem("user_refresh_token", data.refresh);
      localStorage.setItem("user_data", JSON.stringify(data.user));

      localStorage.removeItem("admin_access_token");
      localStorage.removeItem("admin_refresh_token");
      localStorage.removeItem("admin_user");

      navigate("/inicio", {
        replace: true,
      });
    } catch (error) {
      localStorage.removeItem("user_access_token");
      localStorage.removeItem("user_refresh_token");
      localStorage.removeItem("user_data");

      setMessage(
        error instanceof Error
          ? error.message
          : "No fue posible conectar con el servidor."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f4f4f5",
        padding: 3,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -120,
          right: -100,
          width: 310,
          height: 310,
          borderRadius: "50%",
          backgroundColor: "#000000",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: -95,
          left: -70,
          width: 230,
          height: 230,
          borderRadius: "50%",
          backgroundColor: "#b00020",
        }}
      />

      <Paper
        elevation={0}
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 430,
          padding: {
            xs: 3,
            sm: 5,
          },
          border: "1px solid #e1e1e4",
          borderRadius: 3,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="AccessHub"
          sx={{
            width: 86,
            height: 86,
            display: "block",
            objectFit: "contain",
            margin: "0 auto 20px",
          }}
        />

        <Typography
          component="h1"
          sx={{
            color: "#111111",
            textAlign: "center",
            fontSize: 30,
            fontWeight: 800,
            marginBottom: 1,
          }}
        >
          AccessHub
        </Typography>

        <Typography
          sx={{
            color: "#6b7280",
            textAlign: "center",
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 4,
          }}
        >
          Ingresa para continuar.
        </Typography>

        {message && (
          <Alert severity="error" sx={{ marginBottom: 3 }}>
            {message}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            name="email"
            type="email"
            label="Correo"
            value={formData.email}
            onChange={handleChange}
            autoComplete="username"
            disabled={loading}
            sx={{ marginBottom: 2 }}
          />

          <TextField
            fullWidth
            required
            name="password"
            type="password"
            label="Contraseña"
            value={formData.password}
            onChange={handleChange}
            autoComplete="current-password"
            disabled={loading}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              minHeight: 44,
              marginTop: 3,
              borderBottom: "3px solid #b00020",
            }}
          >
            {loading ? (
              <CircularProgress size={22} sx={{ color: "#ffffff" }} />
            ) : (
              "Ingresar"
            )}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}